var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2777 2638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2766.21 274.159C2766.21 274.159 2810.31 143.479 2715.57 52.0029C2628.99 -32.9391 2516.28 12.7989 2516.28 12.7989C2416.64 61.8039 1575.38 579.623 1263.39 922.658C1122.9 1079.47 926.885 1541.75 1085.33 1710.01C1235.62 1870.09 1732.2 1682.24 1867.78 1546.66C2204.28 1210.15 2718.83 375.436 2766.21 274.159V274.159ZM0.69043 2574.13C387.83 2319.3 239.181 2017.1 528.311 1816.18C680.226 1710.01 890.948 1714.91 1031.43 1863.55C1134.34 1973 1162.11 2283.36 1005.29 2428.75C748.833 2665.6 351.893 2681.94 0.69043 2574.13V2574.13Z",
    className: "svgText"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomize);
export default __webpack_public_path__ + "static/media/customize.3725bc38d802cec01a53f94e3b07cc15.svg";
export { ForwardRef as ReactComponent };